import React from "react";
import { Container } from "react-bootstrap";
import ReactGA from 'react-ga';

export default function WorkInProgress () {
    ReactGA.pageview(window.location.pathname + window.location.search);    
    return (
        <Container className='mt-5'>
            <h3>This function will be added soon</h3>
        </Container>
    )
}
